import '../imagehome2/image2.css'
export default function Image2(){
    return(
        <div className="image2">
            {/* <img src={image22} alt="" /> */}
        </div>
    )
}